import { render, staticRenderFns } from "./ActionButton2.vue?vue&type=template&id=33076788&scoped=true"
import script from "./ActionButton2.vue?vue&type=script&lang=js"
export * from "./ActionButton2.vue?vue&type=script&lang=js"
import style0 from "./ActionButton2.vue?vue&type=style&index=0&id=33076788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33076788",
  null
  
)

export default component.exports